import _ from 'lodash';
import React from 'react';
import autobind from 'autobind-decorator';
import InputMask from 'react-input-mask';

import Field from './field';

let UNDEF;

class MaskedInput extends Field {
	renderInput () {
		const { fieldKey, dataId, store, formStore, placeholder } = this.props;
		const { mask, valueKey, setFilter = (val) => val } = formStore.get(fieldKey);

		let value = this.getValue({ store, fieldKey, dataId, valueKey, setFilter });

		// React hates passing null to a controlled input, so force undefined when empty
		value = _.isNull(value) ? undefined : value;

		return (
			<div>
				<InputMask
					mask={ mask }
					placeholder={placeholder}
					data-key={ fieldKey }
					data-ta={ fieldKey }
					value={ value }
					type="text"
					onChange={ (e) => this.handleChange(e) }
					onBlur={ (e) => this.handleChange(e) } />
			</div>
		);
	}
}

export default MaskedInput;
